import {AfterContentInit, Component, ElementRef} from "@angular/core";

// The Infinity Gauntlet -> tig
@Component({
	selector: "[tigCheck]",
	styleUrls: ["./my-check.component.css"],
	template: `
		<div class="tig-check" [ngClass]="{'checked': OBJ_input.checked, 'disabled': OBJ_input.disabled}">
			<ng-content></ng-content>
		</div>
	`
})

export class MyCheckComponent implements AfterContentInit
{


	/**
	 * Attributes
	 */
	BOO_checked: boolean = false;
	BOO_disabled: boolean = false;
	OBJ_input: HTMLInputElement;


	/**
	 * Function > constructor
	 * @param {ElementRef} OBJ_element_ref
	 */
	constructor(private OBJ_element_ref: ElementRef) {} // end function constructor


	/**
	 * Function > ngAfterContentInit
	 */
	ngAfterContentInit()
	{
		this.OBJ_input = this.OBJ_element_ref.nativeElement.querySelector("input");
	} // end function ngAfterContentInit


} // end class MyCheckComponent
